import { createContext } from 'react'

const languageManager = createContext()

export default languageManager
